// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".menumobilefade-enter-active[data-v-21d7139b],.menumobilefade-leave-active[data-v-21d7139b]{transition:opacity .25s}.menumobilefade-enter[data-v-21d7139b],.menumobilefade-leave-to[data-v-21d7139b]{opacity:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
